<template>
  <div @click="resetOptionWrapperWidth" :class="componentClass">
    <div class="gc-select2" id="multi-select">
      <select ref="input" style="width: 100%;">
        <slot></slot>
      </select>
      <transition>
        <div ref="inputBottomDiv"></div>
      </transition>
    </div>
    <text-content
      :weight="'medium'"
      :size="'sm1'"
      :lineHeight="'multi'"
      ref="errorMessage"
      class="gc-select2__error-message" v-if="haveError">{{errorMessage}}</text-content>
  </div>
</template>
<script>
import TextContent from '../../root/TextContent'
export default {
  components: { TextContent },
  name: 'Select2',
  props: {
    hasError: {
      default: false

    },
    options: {
      default: []
    },
    value: {
      type: Array,
      default () {
        return []
      }
    },
    multiple: {
      default: true
    },
    placeHolder: {
      default: ''
    },
    disabled: {
      default: false
    },
    errorMessage: {
      default: ''
    },
    maxSelected: {
      type: Number,
      default: 0
    },
    maxSelectedTitle: {
      default: ''
    }
  },
  data: function () {
    return {
      elementID: '',
      dropdownOptions: {},
      errorClass: '',
      haveError: false,
      noResultMessage: this.$i18n.t('message["general.no-results"]'),
      maximumSelectedMessage: this.$i18n.t('message["validation.limit_selected_options"]').replace('{_field_}', this.maxSelectedTitle).replace('{limit}', this.maxSelected)
    }
  },
  computed: {
    componentClass: function () {
      let classes = { 'gc-input-multi-select': true
      }
      classes['gc-input-multi-select' + this.elementID] = true
      classes['gc-input-multi-select--error'] = this.hasError
      return classes
    }
  },
  beforeMount () {
    this.elementID = Math.floor(Math.random() * 10000) + 1
    window.addEventListener(
      'orientationchange',
      this.handleOrientationChange
    )
  },
  mounted: function () {
    let currentElementByClass = '.gc-input-multi-select' + this.elementID
    // if prop not initialised make it empty
    if (!this.options) {
      this.options = {}
    }
    const vm = this
    let value = this.value
    let selectOptions = []
    this.dropdownOptions = this.options
    if (this.options.length === 1) {
      value = this.options[0].id
    } else if (this.dropdownOptions.length === 1) {
      value = this.dropdownOptions[0].id
      selectOptions = this.dropdownOptions
    }
    if (Array.isArray(this.options) && this.options.length > 0) {
      selectOptions = this.options
    } else if (Array.isArray(this.dropdownOptions) && this.dropdownOptions.length > 0) {
      selectOptions = this.dropdownOptions
    }
    let noResult = this.noResultMessage
    let maxSelectedMessage = this.maximumSelectedMessage
    $(this.$refs.input)
    // init select2
      .select2(
        {
          'language': {
            'noResults': function () {
              return noResult
            },
            'maximumSelected': function () {
              return maxSelectedMessage
            }
          },
          disabled: this.disabled,
          data: selectOptions,
          multiple: this.multiple,
          placeholder: this.placeHolder,
          containerCssClass: this.errorClass,
          dropdownCssClass: 'dropdownCssClass',
          maximumSelectionLength: this.maxSelected,
          sorter: function (data) {
            return data.sort(function (a, b) {
              return a.text < b.text ? -1 : a.text > b.text ? 1 : 0
            })
          }
        })
      .val(value)
      .trigger('change')
    // emit event on change.

      .on('change', function () {
        // removing manually set first load height
        let errorMessageHeight = $(currentElementByClass + ' .gc-select2__error-message').outerHeight() || 0
        let selectedHeight = $(currentElementByClass + ' .select2-selection__rendered').outerHeight()
        let selectedContainerHeight = $(currentElementByClass + ' .select2-container').outerHeight()
        $(currentElementByClass).height(errorMessageHeight + selectedHeight + selectedContainerHeight)
        $(currentElementByClass + ' .select2-selection__arrow').hide()
        if ($(this).val()) {
          vm.$emit('input', $(this).val())
          vm.$emit('change', $(this).val())
        } else {
          vm.$emit('input', [])
          vm.$emit('change', [])
        }
      }).on('select2:select', function () {
        let selectedWidth = $(currentElementByClass + ' .select2-selection__rendered')
        let inputWrapperWidth = $(currentElementByClass + ' .select2-selection--multiple').outerWidth()
        $(selectedWidth).width(inputWrapperWidth)
        // vm.$emit('inputs', $(this).val())
        // vm.$emit('change', $(this).val())
      }).on('select2:unselecting', function () {
        $(this).data('unselecting', true)
      }).on('select2:opening', function (e) {
        if ($(this).data('unselecting')) {
          $(this).removeData('unselecting')
          e.preventDefault()
        }
      }).on('select2:open', function (e) {
        if (!this.multiple) {
          $(currentElementByClass + ' .select2-container--open').addClass('select2-container--single1')
          $(currentElementByClass + ' .select2-selection__arrow').hide()
          $(currentElementByClass + ' .select2-container--below.select2-container--single.select2-container--open').hide()
        }
      }).on('select2:closing', (e) => {
        if (!this.multiple) {
          $(currentElementByClass + ' .select2-container--below.select2-container--single.select2-container--open').show()
        } else {
          $(this.$refs.inputBottomDiv).height($(currentElementByClass + ' .select2-selection__rendered').height())
        }
      })
    this.resetOptionWrapperHeight()
    $(this.$refs.inputBottomDiv).height($(currentElementByClass + ' .select2-selection__rendered').height())
    window.addEventListener('resize', this.windowResize)
  },
  methods: {
    handleOrientationChange () {
      setTimeout(() => {
        this.resetOptionWrapperWidth()
      }, 500)
      setTimeout(() => {
        this.$emit('change')
      }, 1500)
    },
    windowResize (event) {
      setTimeout(() => {
        this.resetOptionWrapperHeight()
      }, 1000)
      this.resetOptionWrapperHeight()
    },
    resetOptionWrapperHeight () {
      this.$nextTick(() => {
        let currentElementByClass = '.gc-input-multi-select' + this.elementID

        let errorMessageHeight = $(currentElementByClass + ' .gc-select2__error-message').outerHeight() || 0
        let selectedHeight = $(currentElementByClass + ' .select2-selection__rendered').outerHeight()
        let selectedContainerHeight = $(currentElementByClass + ' .select2-container').outerHeight()

        $(currentElementByClass).height(errorMessageHeight + selectedHeight + selectedContainerHeight)
        this.$emit('change')
      })
    },
    resetOptionWrapperWidth () {
      this.$nextTick(() => {
        let currentElementByClass = '.gc-input-multi-select' + this.elementID
        let selectedWidth = $(currentElementByClass + ' .select2-selection__rendered')
        let inputWrapperWidth = $(currentElementByClass + ' .select2-selection--multiple').outerWidth()
        let searchFeild = document.querySelector('.select2-search__field')
        if (searchFeild) {
          searchFeild.style.maxWidth = inputWrapperWidth - 40 + 'px'
          $(selectedWidth).width(inputWrapperWidth)
        }

        setTimeout(() => {
          this.$emit('change')
        }, 500)
        $(this.$refs.inputBottomDiv).height($(currentElementByClass + ' .select2-selection__rendered').height())
      })
    }
  },
  watch: {
    errorMessage: {
      handler: function () {
        if (this.errorMessage.length > 0) {
          this.errorClass = 'gc-select2__error'
          this.haveError = true
          this.value = ''
        }
        this.resetOptionWrapperHeight()
      },
      immediate: true
    },
    options: function (options) {
      this.dropdownOptions = options
      // update options
      $(this.$refs.input)
        .empty()
        .select2({
          data: this.dropdownOptions,
          multiple: this.multiple,
          placeholder: this.placeHolder,
          containerCssClass: 'error',
          dropdownCssClass: 'dropdownCssClass',
          sorter: function (data) {
            return data.sort(function (a, b) {
              return a.text < b.text ? -1 : a.text > b.text ? 1 : 0
            })
          }
        })
      // set default values
      $(this.$refs.input).val(this.value).trigger('change')
      // set main wrapper height first load

      this.resetOptionWrapperHeight()
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.windowResize)
    $(this.$refs.input).hide()
    $(this.$refs.input)
      .off()
      .select2('destroy')
  }
}
</script>
